export const PRACTICE_SESSION_CHECKPOINT_SECONDS = [10 * 60, 20 * 60];

export function createPracticeSessionRecordId(practiceStartId, mode = 'practice') {
  const source = practiceStartId || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  const safeMode = String(mode || 'practice').replace(/[^A-Za-z0-9_-]/g, '-').slice(0, 32);
  const safeSource = String(source).replace(/[^A-Za-z0-9_-]/g, '-').slice(0, 110);
  return `practice-session:${safeMode}:${safeSource}`;
}

export function getPendingPracticeCheckpoint(elapsedSeconds, lastSavedSeconds = 0) {
  return PRACTICE_SESSION_CHECKPOINT_SECONDS.find((seconds) => (
    elapsedSeconds >= seconds && lastSavedSeconds < seconds
  )) || null;
}
